import axios from 'axios';

// Use relative URL to leverage Vite proxy in development, or env var in production
const API_URL = import.meta.env.VITE_API_URL || '';

// Check if we have valid Clerk keys
const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const hasValidClerkKey = clerkPubKey && clerkPubKey.startsWith('pk_') && clerkPubKey.length > 30;

// Check if user is signed in (for dev mode)
function isDevAuthenticated() {
  try {
    const authData = localStorage.getItem('backlinkguard_dev_auth');
    if (authData) {
      const parsed = JSON.parse(authData);
      return parsed.isSignedIn === true;
    }
  } catch (e) {
    console.error('Error checking dev auth:', e);
  }
  return false;
}

const client = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
client.interceptors.request.use(async (config) => {
  // In dev mode, add the dev auth header if signed in
  if (!hasValidClerkKey && isDevAuthenticated()) {
    config.headers['X-Dev-Auth'] = 'dev_authenticated';
  }

  // Clerk handles auth via cookies in production
  return config;
});

// Handle errors
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear dev auth state on 401
      if (!hasValidClerkKey) {
        localStorage.setItem('backlinkguard_dev_auth', JSON.stringify({ isSignedIn: false }));
      }
      // Redirect to login on 401
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;
